<template>
  <mp-sliding-panel
    :expanded="show"
    title="Add Job"
    icon="text-single"
    subtitle="Add a new job"
    @close="$emit('close')"
  >
    <add-job-form @close="$emit('close')" @input="$emit('input', $event)" />
  </mp-sliding-panel>
</template>

<script>
import AddJobForm from "./internal/AddJobForm";
export default {
  name: "JobsAddJob",
  components: { AddJobForm },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped></style>
